import { render, staticRenderFns } from "./PointCharge.vue?vue&type=template&id=4e3e60ec&scoped=true"
import script from "./PointCharge.vue?vue&type=script&lang=js"
export * from "./PointCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e60ec",
  null
  
)

export default component.exports